import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';

import { IconButton } from '@mui/material';
import dayjs from 'dayjs';
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

type Props = {
  date: Date;
  loading: boolean;
  onToday: VoidFunction;
  onNextDate: VoidFunction;
  onPrevDate: VoidFunction;
  onCreate: VoidFunction;
};

export default function CalendarToolbar({
  date,
  loading,
  onToday,
  onNextDate,
  onPrevDate,
  onCreate,
}: Props) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      flexWrap="wrap"
      gap={1}
      sx={{ p: 2.5, pr: 2, position: 'relative' }}
    >
      <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap">
        <Stack direction="row" alignItems="center" spacing={1}>
          <IconButton onClick={onPrevDate}>
            <Iconify icon="eva:arrow-ios-back-fill" />
          </IconButton>

          <Typography variant="h6">{dayjs(date).format('DD MMMM BBBB')}</Typography>

          <IconButton onClick={onNextDate}>
            <Iconify icon="eva:arrow-ios-forward-fill" />
          </IconButton>
        </Stack>
        <Button size="small" color="inherit" variant="outlined" onClick={onToday}>
          Today
        </Button>
      </Stack>

      <Button
        variant="contained"
        startIcon={<Iconify icon="mingcute:add-line" />}
        onClick={onCreate}
        sx={{ width: '100%', maxWidth: 160 }}
      >
        สร้างวันหยุด
      </Button>

      {loading && (
        <LinearProgress
          color="inherit"
          sx={{
            height: 2,
            width: 1,
            position: 'absolute',
            bottom: 0,
            left: 0,
          }}
        />
      )}
    </Stack>
  );
}
